import { render, staticRenderFns } from "./OutboundDocument.vue?vue&type=template&id=02ddd17f&scoped=true&"
import script from "./OutboundDocument.vue?vue&type=script&lang=js&"
export * from "./OutboundDocument.vue?vue&type=script&lang=js&"
import style0 from "./OutboundDocument.vue?vue&type=style&index=0&id=02ddd17f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ddd17f",
  null
  
)

export default component.exports